import { Type } from "@themes/pollinator/ui/Type";
import { TwoColumnsLayout } from "@themes/pollinator/ui/TwoColumnsLayout";
import { ClipboardCopyButton } from "@themes/pollinator/ui/ClipboardCopyButton";
import { OutreachItem } from "./OutreachItem";

export type Props = {
  /** Title for the section */
  title?: string;
  /** Description for the section */
  description?: string;
  /** Rich/HTML text content */
  richText: string;
  /** Plain text content */
  plainText: string;
  /** Formatted email subject (optional) */
  formattedSubject?: string;
  /** Section name for tracking copy events */
  sectionName: string;
};

/**
 * Displays long-form text content with copy buttons for different formats.
 */
export function OutreachLongText({
  title,
  description,
  richText,
  plainText,
  formattedSubject,
  sectionName,
}: Props) {
  return (
    <OutreachItem
      title={title}
      description={description}
      innerClassName="flex flex-row gap-2 w-full"
    >
      <div className="flex flex-col gap-6 w-full">
        <Type variant="h5">Click to copy</Type>
        <TwoColumnsLayout layout="even">
          <div className="flex flex-col flex-wrap gap-2">
            <ClipboardCopyButton
              textToCopy={richText}
              label="Rich/Formatted"
              className="w-fit"
              type="rich"
              sectionName={sectionName}
            />
            <ClipboardCopyButton
              textToCopy={plainText}
              label="Plain text"
              className="w-fit"
              type="plain"
              sectionName={sectionName}
            />
            <ClipboardCopyButton
              textToCopy={richText}
              label="HTML"
              className="w-fit"
              type="rich"
              sectionName={sectionName}
            />
          </div>
          <div>
            <div className="border rounded-sm overflow-hidden">
              {formattedSubject && (
                <div className="bg-brand-50/50 p-8 border-b border-border">
                  <Type
                    variant="caption"
                    className="font-medium text-primary-700 mb-2"
                  >
                    Subject:
                  </Type>
                  <Type variant="body2">{formattedSubject}</Type>
                </div>
              )}
              <div className="bg-brand-50 p-8">
                <div
                  data-copy-content={sectionName}
                  dangerouslySetInnerHTML={{
                    __html: richText,
                  }}
                />
              </div>
            </div>
          </div>
        </TwoColumnsLayout>
      </div>
    </OutreachItem>
  );
}

